// import utils
import { alpha } from "@mui/material/styles";
import { SINGLE } from "../../../constants/numbers.consts.js";
const BACKGROUND_OPACITY = 0.24;
export default {
    styleOverrides: {
        root: ({ theme }) => ({
            height: "40px",
            width: "40px",
            padding: theme.spacing(SINGLE),
            "&:hover": {
                backgroundColor: alpha(theme.palette.surface.onVariant, BACKGROUND_OPACITY),
            },
        }),
    },
};
